import React, { useState } from 'react';
import { Rnd } from 'react-rnd';
import './SummaryCard.css';

const SummaryCard = ({ data }) => {
  if (data == null) {
      return (
    <Rnd
      default={{
        x: 0,
        y: 0,
        width: 500,
        height: 300
      }}
      bounds="parent"
    // dragHandleClassName="summary-card-header"
    /*enableResizing={{
      top: true,
      right: true,
      bottom: true,
      left: true,
      topRight: true,
      bottomRight: true,
      bottomLeft: true,
      topLeft: true
    }}*/
    >
      <div id="summary-card" className="summary-card">
        <h2 className="summary-card-header">Pipeline Route Summary</h2>
        <p>
          <strong>Loading...</strong>
        </p>
      </div>
    </Rnd>
  ); 
  }

  const { length, summary } = data;
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (label) => {
    setExpanded((prev) => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  const totalCost = Object.values(summary).reduce((acc, category) => {
    const { Total, ...subFeatures } = category;
    const categoryCost = Object.values(subFeatures).reduce((sum, { cost }) => sum + cost, 0);
    return acc + categoryCost;
  }, 0);

  return (
    <Rnd
      default={{
        x: 0,
        y: 0,
        width: 500,
        height: 300
      }}
      bounds="parent"
    // dragHandleClassName="summary-card-header"
    /*enableResizing={{
      top: true,
      right: true,
      bottom: true,
      left: true,
      topRight: true,
      bottomRight: true,
      bottomLeft: true,
      topLeft: true
    }}*/
    >
      <div id="summary-card" className="summary-card">
        <h2 className="summary-card-header">Pipeline Route Summary</h2>
        <p>
          <strong>Total Length:</strong>{' '}
          {(length / 1000).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })} km
        </p>
        <p>
          <strong>Total Cost:</strong>{' '}
          €{(totalCost).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </p>
        <table className="tree-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Total</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(summary).map(([mainKey, subItems]) => {
              const { Total, ...subFeatures } = subItems;
              return (
                <React.Fragment key={mainKey}>
                  <tr
                    className="parent-row"
                    onClick={() => toggleExpand(mainKey)}
                  >
                    <td>
                      <span className="toggle-icon">
                        {expanded[mainKey] ? '▼' : '▶'}
                      </span>{' '}
                      {mainKey}
                    </td>
                    <td>{Total?.count.toLocaleString('es-ES') ?? '0'}</td>
                    <td>€{Total?.cost.toLocaleString('es-ES') ?? '0'}</td>
                  </tr>
                  {expanded[mainKey] &&
                    Object.entries(subFeatures).map(([subLabel, { count, cost }]) => (
                      <tr key={subLabel} className="child-row">
                        <td>{subLabel}</td>
                        <td>{count.toLocaleString('es-ES')}</td>
                        <td>€{cost.toLocaleString('es-ES')}</td>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </Rnd>
  );
};

export default SummaryCard;
